<template>
  <aside class="site-sidebar">
    <div class="sidebar-inner">
      <router-link to="/" class="brand">
        <img src="@/assets/daohan-logo.png" alt="道晗漫画平台" class="brand-logo">
        <span class="brand-text">
          <strong>道晗漫画平台</strong>
          <small>漫画阅读空间</small>
        </span>
      </router-link>

      <nav class="side-nav" aria-label="主导航">
        <router-link to="/" class="nav-item" :class="{ active: $route.path === '/' }">
          <span class="nav-mark"></span>
          <span>首页</span>
        </router-link>
        <router-link to="/category" class="nav-item" :class="{ active: $route.path === '/category' }">
          <span class="nav-mark"></span>
          <span>全部漫画</span>
        </router-link>
        <router-link to="/ranking" class="nav-item" :class="{ active: $route.path === '/ranking' }">
          <span class="nav-mark"></span>
          <span>排行榜</span>
        </router-link>
        <router-link to="/community" class="nav-item" :class="{ active: $route.path.startsWith('/community') }">
          <span class="nav-mark"></span>
          <span>社区讨论</span>
        </router-link>
        <router-link to="/youth-protection" class="nav-item" :class="{ active: $route.path.startsWith('/youth-protection') }">
          <span class="nav-mark"></span>
          <span>青少年模式</span>
        </router-link>
        <router-link to="/vip" class="nav-item vip-link" :class="{ active: $route.path === '/vip' }">
          <span class="nav-mark"></span>
          <span>充值服务</span>
        </router-link>
        <router-link to="/about" class="nav-item" :class="{ active: $route.path === '/about' }">
          <span class="nav-mark"></span>
          <span>关于我们</span>
        </router-link>
        <router-link to="/copyright" class="nav-item" :class="{ active: $route.path === '/copyright' }">
          <span class="nav-mark"></span>
          <span>版权声明</span>
        </router-link>
      </nav>

      <div class="sidebar-search">
        <label for="global-search">搜索漫画</label>
        <div class="search-box">
          <input
            id="global-search"
            type="text"
            placeholder="输入漫画名..."
            v-model="searchKeyword"
            @keyup.enter="performSearch"
          >
          <button @click="performSearch">搜索</button>
        </div>

        <div class="search-results" v-if="showSearchResults && searchResults.length > 0">
          <div class="result-item" v-for="item in searchResults" :key="item.id" @click="goToComicDetail(item.id)">
            <div class="result-cover">
              <img :src="getFullImageUrl(item.cover)" :alt="item.title">
            </div>
            <div class="result-info">
              <h4>{{ item.title }}</h4>
              <p>{{ item.author }}</p>
            </div>
          </div>
          <div class="view-all" v-if="searchTotal > searchResults.length" @click="viewAllResults">
            查看全部 {{ searchTotal }} 个结果
          </div>
        </div>

        <div class="search-results" v-if="showSearchResults && searchKeyword && searchResults.length === 0">
          <div class="no-result">
            <p>无法找到“{{ searchKeyword }}”相关的漫画</p>
          </div>
        </div>
      </div>

      <div class="sidebar-user">
        <template v-if="isLoggedIn">
          <div class="user-info">
            <img :src="userInfo.avatar" :alt="userInfo.nickname" class="user-avatar" @click.stop="goToUserCenter">
            <span class="user-meta" @click.stop="goToUserCenter">
              <strong>{{ userInfo.nickname }}</strong>
              <small v-if="userInfo.is_vip">VIP会员</small>
              <small v-else>普通会员</small>
            </span>
            <button class="user-menu-toggle" type="button" @click.stop="toggleUserMenu" aria-label="打开用户菜单">···</button>
            <div class="user-menu" v-if="showUserMenu" @click.stop>
              <div class="menu-item" @click="handleLogout">退出登录</div>
            </div>
          </div>
        </template>
        <template v-else>
          <router-link to="/login" class="login-btn">登录</router-link>
          <router-link to="/login?tab=register" class="register-btn">注册</router-link>
        </template>
      </div>
    </div>
  </aside>
</template>

<script>
import api from '../api/index'
import request from '../api/request'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'SiteHeader',
  setup() {
    const router = useRouter()
    const route = useRoute()

    return {
      router,
      route
    }
  },
  data() {
    return {
      isLoggedIn: false,
      userInfo: {},
      showUserMenu: false,
      searchKeyword: '',
      searchResults: [],
      searchTotal: 0,
      showSearchResults: false,
      isSearching: false
    }
  },
  mounted() {
    this.checkLoginStatus()
    document.addEventListener('click', this.handleOutsideClick)
    // 用户资料（头像/昵称）更新后同步刷新侧边栏
    window.addEventListener('user-info-updated', this.fetchUserInfo)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick)
    window.removeEventListener('user-info-updated', this.fetchUserInfo)
  },
  methods: {
    goToUserCenter() {
      this.router.push('/user')
      this.showUserMenu = false
    },
    goToVip() {
      this.router.push('/vip')
    },
    toggleUserMenu(event) {
      if (event) event.stopPropagation()
      this.showUserMenu = !this.showUserMenu
    },
    handleOutsideClick(event) {
      const userInfoEl = this.$el.querySelector('.user-info')
      if (userInfoEl && !userInfoEl.contains(event.target) && this.showUserMenu) {
        this.showUserMenu = false
      }

      const searchEl = this.$el.querySelector('.sidebar-search')
      if (searchEl && !searchEl.contains(event.target) && this.showSearchResults) {
        this.showSearchResults = false
      }
    },
    handleLogout() {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      this.isLoggedIn = false
      this.userInfo = {}
      this.showUserMenu = false
      window.location.reload()
    },
    checkLoginStatus() {
      const userInfoStr = localStorage.getItem('userInfo')
      const token = localStorage.getItem('token')

      if (userInfoStr && token) {
        try {
          this.userInfo = JSON.parse(userInfoStr)
          this.isLoggedIn = true
          this.fetchUserInfo()
        } catch (error) {
          console.error('解析用户信息失败:', error)
          this.handleLogout()
        }
      }
    },
    async fetchUserInfo() {
      try {
        const result = await api.getUserInfo()

        if (result && result.data) {
          this.userInfo = result.data
          localStorage.setItem('userInfo', JSON.stringify(result.data))
        } else if (!result || result.data === null) {
          const cachedUserInfo = localStorage.getItem('userInfo')
          if (cachedUserInfo) {
            this.userInfo = JSON.parse(cachedUserInfo)
          } else {
            this.userInfo = {
              nickname: '用户',
              avatar: 'https://via.placeholder.com/30'
            }
          }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)

        if (error.message.includes('登录已过期')) {
          this.handleLogout()
        } else {
          const cachedUserInfo = localStorage.getItem('userInfo')
          if (cachedUserInfo) {
            this.userInfo = JSON.parse(cachedUserInfo)
          }
        }
      }
    },
    async performSearch() {
      if (!this.searchKeyword || this.searchKeyword.trim() === '') {
        this.showSearchResults = false
        return
      }

      this.isSearching = true
      try {
        const result = await api.searchComic(this.searchKeyword.trim())

        if (result && result.code === 1 && result.data) {
          this.searchResults = result.data.list || []
          this.searchTotal = result.data.total || 0
          this.showSearchResults = true
        } else {
          this.searchResults = []
          this.searchTotal = 0
          this.showSearchResults = true
        }
      } catch (error) {
        console.error('搜索漫画失败:', error)
        this.searchResults = []
        this.searchTotal = 0
        this.showSearchResults = true
      } finally {
        this.isSearching = false
      }
    },
    goToComicDetail(id) {
      this.showSearchResults = false
      this.router.push(`/comic/${id}`)
    },
    viewAllResults() {
      this.showSearchResults = false
      this.router.push({
        path: '/search',
        query: { keyword: this.searchKeyword }
      })
    },
    getFullImageUrl(cover) {
      if (cover && /^https?:\/\//i.test(cover)) return cover
      if (cover && cover.startsWith('//')) return window.location.protocol + cover
      if (cover && cover.startsWith('/')) return request.baseUrl + cover
      if (cover) return `${request.baseUrl}/${cover}`
      return 'https://via.placeholder.com/80x100'
    }
  }
}
</script>

<style scoped>
.site-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 500;
  width: 236px;
  height: 100vh;
  padding: 16px;
  background:
    radial-gradient(circle at 24% 4%, rgba(255, 187, 79, 0.16), transparent 30%),
    radial-gradient(circle at 78% 22%, rgba(35, 211, 238, 0.12), transparent 34%),
    linear-gradient(180deg, rgba(12, 14, 26, 0.96), rgba(8, 10, 18, 0.94));
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 18px 0 55px rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(24px);
}

.sidebar-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 22px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  color: #f8fbff;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.04));
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.24);
}

.brand-logo {
  width: 52px;
  height: 52px;
  border-radius: 8px;
  object-fit: cover;
  box-shadow: 0 12px 26px rgba(0, 0, 0, 0.34);
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.brand-text strong {
  font-size: 17px;
  letter-spacing: 0;
}

.brand-text small {
  margin-top: 5px;
  color: #91a0bf;
  font-size: 12px;
}

.side-nav {
  display: grid;
  gap: 10px;
}

.nav-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 46px;
  padding: 0 14px;
  color: #aab5d4;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 800;
  transition: all 0.24s ease;
}

.nav-item:hover,
.nav-item.active {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08), 0 12px 28px rgba(0, 0, 0, 0.2);
  transform: translateX(3px);
}

.nav-item.active::after {
  content: "";
  position: absolute;
  right: 12px;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #ffcc66;
  box-shadow: 0 0 0 5px rgba(255, 204, 102, 0.14);
}

.nav-mark {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #353c55;
}

.nav-item.active .nav-mark {
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.vip-link {
  color: #aab5d4;
}

.vip-link .nav-mark {
  background: #353c55;
}

.sidebar-search {
  position: relative;
  padding: 16px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.sidebar-search label {
  display: block;
  margin-bottom: 10px;
  color: #edf3ff;
  font-size: 13px;
  font-weight: 800;
}

.search-box {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
}

.search-box input {
  width: 100%;
  min-width: 0;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 12px 13px;
  color: #f8fbff;
  outline: none;
  background: rgba(5, 7, 14, 0.72);
  transition: all 0.24s ease;
}

.search-box input:focus {
  border-color: #23d3ee;
  background: #080b16;
  box-shadow: 0 0 0 4px rgba(35, 211, 238, 0.12);
}

.search-box button {
  border: 0;
  border-radius: 8px;
  padding: 0 14px;
  color: #09101d;
  font-weight: 800;
  cursor: pointer;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.search-results {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  right: 0;
  max-height: 360px;
  overflow-y: auto;
  z-index: 560;
  background: #111525;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 18px 46px rgba(0, 0, 0, 0.38);
}

.result-item {
  display: flex;
  gap: 10px;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  transition: background-color 0.2s;
}

.result-item:hover {
  background: rgba(255, 255, 255, 0.06);
}

.result-cover {
  flex: 0 0 42px;
  height: 58px;
}

.result-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.result-info {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.result-info h4 {
  margin: 0 0 5px;
  color: #f8fbff;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.result-info p,
.no-result {
  color: #9aa7c3;
  font-size: 12px;
}

.view-all {
  padding: 12px;
  color: #23d3ee;
  text-align: center;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
}

.no-result {
  padding: 18px;
  text-align: center;
}

.sidebar-user {
  margin-top: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.login-btn,
.register-btn {
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-weight: 800;
}

.login-btn {
  color: #eaf1ff;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
}

.register-btn {
  color: #09101d;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
  box-shadow: 0 10px 24px rgba(255, 204, 102, 0.18);
}

.user-info {
  grid-column: 1 / -1;
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  cursor: pointer;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.24);
}

.user-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
}

.user-meta {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  color: #edf3ff;
  cursor: pointer;
}

.user-meta strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}

.user-meta small {
  margin-top: 3px;
  color: #9aa7c3;
  font-size: 12px;
}

.user-menu-toggle {
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 8px;
  color: #dfe7ff;
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.08);
}

.user-menu-toggle:hover {
  color: #07101d;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.user-menu {
  position: absolute;
  right: 0;
  bottom: calc(100% + 10px);
  width: 150px;
  overflow: hidden;
  border-radius: 10px;
  background: #111525;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 18px 46px rgba(0, 0, 0, 0.38);
}

.menu-item {
  padding: 12px 14px;
  color: #dce6ff;
  font-size: 14px;
  transition: background-color 0.2s;
}

.menu-item:hover {
  background: rgba(255, 255, 255, 0.06);
}

@media (max-width: 920px) {
  .site-sidebar {
    position: sticky;
    width: 100%;
    height: auto;
    padding: 12px;
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.28);
  }

  .sidebar-inner {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .brand-logo {
    width: 54px;
    height: 54px;
  }

  .side-nav {
    display: flex;
    overflow-x: auto;
    padding-bottom: 2px;
  }

  .nav-item {
    flex: 0 0 auto;
    min-height: 42px;
    padding: 0 13px;
  }

  .sidebar-search {
    padding: 12px;
  }
}
</style>
